import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'

class UserApiManager {
    static getUser = () => {
        // Get user data from local storage
        var userData = localStorage.getItem('userData')

        var userId = JSON.parse(userData)?.userId
        // Check if userId is available
        if (!userId) {
            throw new Error('User ID not found in local storage')
        }
        return ApiMethods.get(ENDPOINTS.GET_USER(userId));
    }

    static editUser = (data) => {
        // Get user data from local storage
        var userData = localStorage.getItem('userData')

        var userId = JSON.parse(userData)?.userId
        // Check if userId is available
        if (!userId) {
            throw new Error('User ID not found in local storage')
        }
        return ApiMethods.patch(ENDPOINTS.EDIT_USER(userId), data);
    }
}

export default UserApiManager
